import { ElementRef } from '@angular/core';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BoObject, FormatOption, ModelMail, PropertyObject } from '../models';
import { ModelEmailModel } from '../models/model-email';
import { HttpService, CoreService } from '../services';
import { ToastService } from '../toast';
import { isEmptyStr, isNullObj } from '../utilities';
declare var require: any;
const ClassicEditor: any = require('../../../app-queoval/src/assets/ckeditor5/build/ckeditor');
declare var $: any;

@Component({
  selector: 'q-ModelEmail',
  templateUrl: './model-email.component.html',
  styleUrls: ['./model-email.component.css']
})

export class ModelEmailComponent implements OnInit {

 
  constructor(
    protected indParam: CoreService,
    protected http: HttpService,
    protected toastservice: ToastService
  ) { }
  @Input() set ListBo(value: Array<string>) {
    this._listBo = value;
  }
  private _listBo: Array<string> = new Array<string>();
  @Input() set GroupeModelMail(value: string) {
    this._groupeModelMail = value;
  }
  private _groupeModelMail: string;



  // #region variables globales
  /**
   * Liste des modèles de mail
   */
  public listModelsMail: ModelMail[];
  /**
   * Modèle de mail sélectionné
   */
  public selectedModelMail: ModelMail;

  /**
   * Nom du model
   */
  public modelName: string;

  /**
   * Si c'est le modèle par défaut
   */
  public isDefaultModel: boolean;

  /**
   * Affichage erreur à la suppression
   */
  public showErrDelete: boolean;
  /**
   * Si le modèle peut être affiché
   */
  public showmodel: boolean;
  /**
   * Liste des BO
   */
  public listBoObject: BoObject[];
  /**
   * Liste des propriétés
   */
  public listProperties: PropertyObject[];
  /**
   * Propriété à copier (celle qui a été générée)
   */
  public propertyToCopy: string;
  // #region CKEDITOR

  public Editor: any = ClassicEditor;

  // #endregion
  /**
   * Select model mail
   */ 
  @ViewChild('selectModel', { static: false }) selectModel: ElementRef;

  /**
   * Modal suppression cycle
   */
  @ViewChild('modalDeleteTemplate', { static: false }) modalDeleteTemplate: ElementRef;

  /**
   * close modale
   */
  @ViewChild('closeDelete', { static: false }) closeDelete: ElementRef;

  /**
   * Erreur à l'enregistrement
   */
  public showErrMod: boolean;

  // #endregion

  // #region cycle de vie
  /**
   * Initialisation du composant
   */
  ngOnInit(): void {
    this.initData();
  }

  // #endregion

  // #region public functions


  // #region OPEN ZONE MODEL

  /**
   * Afficher un nouveau modèl de mail (vide)
   */
  showNewModel(): void {
    this.selectedModelMail = new ModelMail();
    // On affiche pas le modèle existant s'il était sélectionné
    //if (this.listModelsMail !== null && this.listModelsMail !== undefined && this.listModelsMail.length > 0) {
    //  this.selectModel.nativeElement.children[0].children[0].children[0].value = '-------------';
    //}


    // Si c'est un nouveau modèle on la considère par défault
    this.selectedModelMail.IsDefault = true;
    this.showmodel = true;
  }

  /**
   * Chargement d'un model existant
   * @param value Id du modèle de mail sélectionné
   */
  loadModelMailEL(value: string): void {
    if (!isEmptyStr(value)) {
      this.indParam.showSplash(true);
      // Récupération de la liste des modèles de mail E-Learning
      this.http.getHttp<ModelEmailModel>(`${this.indParam.AppParams.apiUrl}api/ModelEmail/GETMODELMAIL/${value}|${this._groupeModelMail}`).subscribe(
        (data: ModelEmailModel) => {
          this.indParam.showSplash(false);
          if (!data.HasError) {
            this.selectedModelMail = data.ModelMailSelected;
            this.modelName = data.ModelMailSelected.InfoModel;
            this.isDefaultModel = data.ModelMailSelected.IsDefault;
            this.showmodel = true;
          }
        }, () => {
        });
    } else {
      this.showmodel = false;
    }
  }

  // #endregion

  // #region SAVE MODEL
  /**
   * Enregistrement du modèle de mail
   */
  saveModelMail(): void {
    this.indParam.showSplash(true);
    // Penser à gérer les cas d'erreur (ici pas d'erreur)...
    const notValid: boolean = isEmptyStr(this.selectedModelMail.InfoModel) || isEmptyStr(this.selectedModelMail.SenderMail);
    if (notValid) {
      this.displayErrMod();
      this.indParam.showSplash(false);
    } else {
      this.showErrMod = false;
      // Enregistrement du model
      const model: ModelEmailModel = new ModelEmailModel();
      model.Mode = 'SAVEMODELMAIL';
      model.ModelMailSelected = this.selectedModelMail;
      model.GroupeModelMail = this._groupeModelMail;
      this.http.postHttp<ModelEmailModel>(`${this.indParam.AppParams.apiUrl}api/ModelEmail/`, model).subscribe(
        (data: ModelEmailModel) => {
          this.indParam.showSplash(false);
          if (!data.HasError) {
            this.toastservice.showSuccessToast(this.indParam.getTrad('Emailtemplatesaved_EL'));

            // Mise à jour de la liste des models
            this.listModelsMail = data.ListModelsMail;

            // Mise à jour du modèle (avec le code)
            this.selectedModelMail = data.ModelMailSelected;
          }
        }, () => {
        });
    }

  }

  /**
   * Affichage / Masquage de l'alert erreur sur l'enregistrement du model
   */
  displayErrMod(): void {
    this.showErrMod = !this.showErrMod;
  }

  // #endregion

  // #region DELETE MODEL

  /**
   * Ouverture modale de suppression d'un modèle de mail
   */
  deleteModelMail(): void {
    this.closeDelete.nativeElement.click();
  }

  /**
   * confirmation de suppression d'u modèle de mail
   */
  confirmDelete(): void {
    // Si le modèle à supprimer est celui par défaut -> affichage du message d'interdiction
    if (!this.isDefaultModel) {
      this.indParam.showSplash(true);
      const model: ModelEmailModel = new ModelEmailModel();
      model.Mode = 'DELETEMODELMAIL';
      model.ModelMailSelected = this.selectedModelMail;
      model.GroupeModelMail = this._groupeModelMail;
      this.http.postHttp<ModelEmailModel>(`${this.indParam.AppParams.apiUrl}api/ModelEmail`, model).subscribe(
        (data: ModelEmailModel) => {
          if (!data.HasError) {
            if (!isNullObj(data)) {
              this.listModelsMail = data.ListModelsMail;
              // Fermeture de la modal et confirmation de la suppression
              this.closeModalDelete();
              this.showmodel = false;
              this.toastservice.showSuccessToast(`${this.indParam.getTrad('Themailtemplate_EL')} ${this.selectedModelMail.InfoModel} ${this.indParam.getTrad('hasbeendeleted_EL')}`);
            }
            this.indParam.showSplash(false);
          }
        }, () => {
        });
    } else {
      this.showErrDelete = true;
    }

  }

  //
  /**
   * Fermeture modale de suppression d'un modèle de mail
   */
  closeModalDelete(): void {
    this.modalDeleteTemplate.nativeElement.className = 'modal hide';
    // Fermeture de l'erreur à la suppression
    this.showErrDelete = false;
  }

  // #endregion

  // #region BO UNION FIELD
  /**
   * Rechargement de la liste des formats lors du changement de propriété sélectionnée
   * @param propjs Propriété sélectionnée (format JSON)
   * @param i indice du BO sur lequel se trouve la propriété
   */
  loadFormatProp(propjs: string, i: number): void {
    if (!isEmptyStr(propjs)) {
      const prop: PropertyObject = JSON.parse(propjs);
      if (!isNullObj(this.listProperties) && this.listProperties.length > 0) {
        this.listProperties.splice(i, 1);
      }
      this.listBoObject.forEach((bo: BoObject) => {
        bo.ListProperties.forEach((p: PropertyObject) => {
          if (p.Code === prop.Code) {
            this.listProperties.push(p);
          }
        });
      });
    }
  }

  /**
   * Pour savoir si une propriétée du bo est choisie et construire la value
   * @param bo BO sur lequel se trouve la propriété
   * @param propjs Propriété choisie (format JSON)
   */
  selectProp(bo: BoObject, propjs: string): void {
    if (!isEmptyStr(propjs)) {
      const prop: PropertyObject = JSON.parse(propjs);
      if (!isNullObj(prop) && !isEmptyStr(prop.Code)) {
        bo.HasPropSelected = true;
        bo.PropSelected = prop;
        bo.FormatSelected = new FormatOption;
      } else {
        bo.HasPropSelected = false;
        bo.PropSelected = new PropertyObject;
        bo.FormatSelected = new FormatOption;
      }
    } else {
      bo.HasPropSelected = false;
      bo.PropSelected = new PropertyObject;
      bo.FormatSelected = new FormatOption;
    }

  }

  //
  /**
   * Pour construire la value avec le format sélectionné
   * @param bo BO sur lequel se trouve le format
   * @param formatjs Format choisi (format JSON)
   */
  selectFormat(bo: BoObject, formatjs: string): void {
    if (!isEmptyStr(formatjs)) {
      const format: FormatOption = JSON.parse(formatjs);
      if (!isNullObj(format)) {
        bo.FormatSelected = format;
      } else {
        bo.FormatSelected = new FormatOption;
      }
    } else {
      bo.FormatSelected = new FormatOption;
    }
  }

  /**
   * Construction du code à afficher
   * @param bo Bo sur lequel se situe le bouton
   */
  createUnionField(bo: BoObject): void {
    if (!isNullObj(bo.PropSelected)) {
      if (bo.PropSelected.Methode === 'COMBO') {
        // Si c'est un combo on ne prend pas le format
        this.propertyToCopy = `[${bo.PropSelected.Code}]`;
      } else {
        if (!isNullObj(bo.FormatSelected) && !isEmptyStr(bo.FormatSelected.Value)) {
          this.propertyToCopy = `[${bo.PropSelected.Code}$${bo.FormatSelected.Value}]`;
        } else {
          this.propertyToCopy = `[${bo.PropSelected.Code}]`;
        }
      }
      this.copyField();
    }
  }

  // #endregion

  // #endregion

  // #region private functions
  /**
   * Récupération de la liste des modèles de mail
   */
  private initData(): void {
    this.indParam.showSplash(true);

    this.listProperties = new Array<PropertyObject>();
    this.selectedModelMail = new ModelMail();



    const model: ModelEmailModel = new ModelEmailModel();
    model.Mode = 'INITDATA';
    model.ListBo = this._listBo;
    model.GroupeModelMail = this._groupeModelMail;
    // Récupération de la liste des modèles de mail
    this.http.postHttp<ModelEmailModel>(`${this.indParam.AppParams.apiUrl}api/ModelEmail`, model).subscribe(
      (data: ModelEmailModel) => {
        if (!data.HasError) {
          this.listModelsMail = data.ListModelsMail;
          this.listBoObject = data.ListBoObject;
          // Chargement du modèle "Par défaut"
          let codeModelToLoad: string = '';
          this.listModelsMail.forEach((modelMail: ModelMail) => {
            if (modelMail.IsDefault) {
              codeModelToLoad = modelMail.CodeModel;
            }
          });
          if (codeModelToLoad !== '') {
            this.loadModelMailEL(codeModelToLoad);
          }
          else {
            this.indParam.showSplash(false);
          }
        }
        else {
          this.indParam.showSplash(false);
        }
      }, () => {
      });
  }

  /**
   * Copie dans presse papier
   */
  private copyField(): void {
    // technique de ninja pour copier le texte dans le presse-papier
    const $temp: any = $('<input>');
    $('body').append($temp);
    $temp.val(this.propertyToCopy).select();
    document.execCommand('copy');
    $temp.val(document.execCommand('copy'));
    // scope.unionField = document.execCommand('copy');
    $temp.remove();
    // popup message copier
    $('#copy').attr('data-original-title', this.indParam.getTrad('textcopiedtotheclipboard_EL')).tooltip('show');
    setTimeout(() => {
      $('#copy').tooltip('hide').attr('data-original-title', '');
    }, 1500);
  }

  // #endregion
}
